export const es = {
    //Elementos generales
    "Clic here": "Haz clic aquí",
    "Edit": "Editar",
    "Preview": "Vista previa",
    "Saving":"Guardando...",
    "Cancel": "Cancelar",
    "Save": "Guardar",


    "Welcome to React": "Bienvenido a react",
    "Log In": "Inicio de sesión",
    "Username": "Nombre de usuario",
    "Password": "Contraseña",
    //Home
    "You can start with": "Puedes comenzar con:",
    "Get the user manual": "Descarga el manual de usuario",
    "Welcome title": "!Bienvenido/a ",
    "Continue title": "Continúa donde lo dejaste",
    "Continue where you left off": "Regresa a tu aprendizaje desde tu última lección vista.",
    "Advances": "Mis Avances",
    "My Advances": "Revisa tu progreso de aprendizaje, tu tiempo en la plataforma y tu última lección visualizada.",
    "Diagnostic title": "Exámen diagnóstico",
    "Diagnostic examination": "Pon a prueba tus conocimientos de Excel y Power BI y obtén un diagnóstico para saber qué temas reforzar antes de tomar tus cursos.",
    "Learning title": "Rutas de aprendizaje",
    "Learning routes": "Crea listas personalizadas con temas de nuestro catálogo de cursos que te interesen.",
    "Entertainment title": "Sala de entretenimiento",
    "Entertainment room": "Entra a la sala de entretenimiento y relájate un momento antes de continuar con tu aprendizaje.",
    "Consulting title": "Agenda de asesorías",
    "Consulting agenda": "¿Necesitas ayuda con temas de paquetería Office? Agenda una consulta con uno de nuestros especialistas y con gusto te apoyaremos.",
    "Pomodoro title": "Técnica Pomodoro",
    "Pomodoro Technique": "Maximiza tu concentración con esta técnica de gestión del tiempo que te ayudará a organizar el tiempo que dedicas a tu aprendizaje.",
    //Pendiente para traducir, falta la app movil
    //   "Download Click+ Mobile": "Administra tu progreso, solicita tu estado de cuenta y disfruta lecciones optimizadas para que las lleves contigo donde quieras. Sin costo adicional.",
    "Admin title": "Panel de administración",
    "Admin Panel": "Gestiona el contenido de la plataforma.",
    "Just for you": "Seleccionado para ti",
    "You might be interested": "Podria interesarte",
    "MOS title": "Certificación MOS",
    "MOS description" : "Prepárate para tu Certificado Microsoft Office Specialist Te ayudará a mejorar tu análisis de datos, la toma de decisiones y optimización de procesos, además de destacar para mejores puestos y oportunidades laborales.",
    "Material seen in training": "Material visto en capacitación",
    "See material": "Ver material",
    "Reviews from our customers": "Reseñas de nuestros clientes",
    "Reviews description" : "Mira los comentarios de nuestras asesorías personalizadas",

    //Atajos para nuevo ingreso
    "Diagnostic test":"Examen diagnóstico",
    "Diagnostic description":"Prueba tu conocimiento en Excel y Power BI y obtén un diagnóstico para saber que temas reforzar antes de tomar tus cursos.",
    "Learning paths": "Rutas de aprendizaje",
    "Learning description" : "Crea listas de reproducción personalizadas con temas de nuestro catálogo de cursos que sea de tu interés.",


    //Listado de cursos

    //Listado de cursos(Descripciones de las categorias)
    "About": "¿De qué va la categoría?",
    "Aprende a utilizar herramientas que agilizan el uso de la computadora como comandos y atajos de Windows, o sobre el uso del Navegador Web con Internet": "Aprende a utilizar herramientas que agilizan el uso de la computadora como comandos y atajos de Windows, o sobre el uso del Navegador Web con Internet",
    "Aprende sobre edición de imágenes con la Paquetería Adobe": "Aprende sobre edición de imágenes con la Paquetería Adobe",
    "Utiliza la Paquetería Office que te ayudarán a realizar tus trabajos de manera eficiente": "Utiliza la Paquetería Office que te ayudarán a realizar tus trabajos de manera eficiente",
    "Analiza y procesa tus datos de ventas y mejorar tus procesos con Power Business Intelligence": "Analiza y procesa tus datos de ventas y mejorar tus procesos con Power Business Intelligence",
    "Obtendrás conocimientos en las herramientas más utilizadas en Home Office como Microsoft Teams, Hangouts o Zoom": "Obtendrás conocimientos en las herramientas más utilizadas en Home Office como Microsoft Teams, Hangouts o Zoom",
    "Aprende programación por bloques con Scratch o a hacer carritos de compra en línea en minutos con Wordpress": "Aprende programación por bloques con Scratch o a hacer carritos de compra en línea en minutos con Wordpress",
    "Conoce conceptos básicos de la Programación Neurolingüística y aprende cómo utilizarlos": "Conoce conceptos básicos de la Programación Neurolingüística y aprende cómo utilizarlos",
    "Adquiere conocimientos básicos y avanzados en el idioma Inglés": "Adquiere conocimientos básicos y avanzados en el idioma Inglés",
    "Adquiere conocimientos en las herramientas necesarias para crear tu tienda en línea": "Adquiere conocimientos en las herramientas necesarias para crear tu tienda en línea",

    //Categorias de la plataforma
    "Informática": "Informática",
    "Diseño": "Diseño",
    "Ofimática": "Ofimática",
    "Inteligencia de Negocios": "Inteligencia de ventas",
    "Home Office": "Home Office",
    "Programación": "Programación",
    "Desarrollo personal": "Desarrollo personal",
    "Idiomas": "Idiomas",
    "E-commerce": "E-commerce",
    //TODO: Falta complementar las categorias con las de los intereses


    //Cursos de la plataforma
    "Internet": "Internet   ",
    "Windows 10": "Windows 10",
    "Photoshop": "Photoshop",
    "Excel Aplicado" : "Excel Aplicado",
    "Excel Intermedio": "Excel Intermedio",
    "Excel Básico": "Excel Básico",
    "Outlook": "Outlook",
    "PowerPoint": "PowerPoint",
    "Word": "Word",
    "Power BI": "Power BI",
    "Power BI Avanzado": "Power BI Avanzado",
    "Microsoft Teams": "Microsoft Teams",
    "Zoom": "Zoom",
    "Programación por bloques con Scratch": "Programación por bloques con Scratch",
    "Comunicación Efectiva": "Comunicación Efectiva",
    "Liderazgo": "Liderazgo",
    "Resiliencia": "Resiliencia",
    "Ética profesional": "Ética profesional",
    "Programación Neurolingüística": "Programación Neurolingüística",
    "Programación Neurolingüística para ventas": "Programación Neurolingüística para ventas",
    "Resolución de conflictos": "Resolución de conflictos",
    "English Beginning":"English Beginning",
    "English Intermediate": "English Intermediate",
    "English High Intermediate":"English High Intermediate",
    "Canva Pro": "Canva Pro",
    "Canva": "Canva",
    "Meta Suite Bussiness": "Meta Suite Bussiness",
    "WordPress": "WordPress",

    "Courses you will find here":"Cursos que encontrarás aquí",

    //navbar
    "Display menu": "Desplegar menú",
    "Search by categories, courses, sections, lessons, learning paths, quick tips, or help forum topics": "Busca por categorías, cursos, secciones, lecciones, rutas de aprendizaje, consejos rápidos o temas de foro de ayuda",
    "Without notifications":"No tienes notificaciones",

    "Pomodoro technique": "Técnica pomodoro",
    "Settings": "Configuración",
    "Notifications": "Notificaciones",
    "Add second user": "Registrar 2° usuario",
    "Change user": "Cambiar usuario",
    "Change password": "Cambiar contraseña",
    "Change username": "Cambiar nombre de usuario",
    "Log out": "Cerrar sesión",


    //Configuracion
    "Settings title": "Configuración",
    "My profile": "Mi perfil",
    "Your account": "Tu cuenta",
    "Contract id": "Folio de contrato",
    "Email": "Email",
    "First name": "Nombre",
    "Last name": "Apellidos",
    "Phone": "Número de teléfono",
    "Username":"Nombre de usuario",
    "Nickname": "Alias de usuario",
    "Profession":"Profesión",
    "Your preferences": "Tus intereses",
    "No preferences": "No has seleccionado tus temas de interés",
    "Select preferencies": "Seleccionar intereses",
    "Your membership": "Tu membresía",
    "License": "Licencia",
    "Role": "Rol",
    "Registration date": "Fecha de registro",
    "Last login": "Fecha de último acceso", 
    "Expiration date": "Fecha de expiración",
    "Remaining time": "Tiempo restante",
    "Courses included in my license": "Mis cursos",

    //Dropzone component
    "dropzone description": "Haz clic aquí para cargar una foto",

    //Sidebar
    "Home":"Inicio",
    "Home description":"Regresa al menú principal",
    "Click+ Misions":"Misiones Click+",
    "Click+ Misions description":"Completa los retos, gana créditos y canjealos por increíbles premios",
    "Quick tips": "Consejos Rápidos",
    "Quick tips description" : "Aumenta tu productividad con la lista de atajos de teclado que tenemos para consultar, en ella encontrarás atajos para toda la paquetería Office y cursos con los que cuenta la plataforma",
    "Help forum notifications": "Foro de Ayuda: Notificaciones Nuevas",
    "Help forum": "Foro de Ayuda",
    "Help forum description": "Interactúa con la comunidad Click+ y comparte temas, opiniones o resuelve dudas que surjan durante tu aprendizaje con apoyo de otros estudiantes",
    "My courses": "Mis Cursos",
    "My courses description": "Disfruta del catálogo de cursos que tenemos para ti. ¡Complétalos todos!",
    "AI Suite": "Suite IA",
    "AI Suite description": "La inteligencia artificial incrementa la productividad y calidad en tu trabajo, explora las diferentes herramientas con inteligencia artificial y libera todo su potencial para aplicarlos en tu día a día",
    "Bussiness forum": "Foro Empresarial",
    "Bussiness forum description": "Mantente en constante contacto con tus colaboradores al asignar tareas o actividades, lleva el control y administra a tu equipo generando un reporte del avance de sus integrantes y de su actividad en la plataforma",
    "Help center": "Centro de Ayuda",
    "Help center description": "¿Necesitas ayuda? Consulta las preguntas más frecuentes para resolver tus dudas que tengas sobre la plataforma y temas de tu licencia Click+",
    "My payments": "Mis pagos",
    "My payments description": "Solicíta tu estado de cuenta o renueva tu licencia Click+.",
    "MOS preparatory course": "Curso Propedéutico MOS",
    "MOS preparatory course description": "Prepárate y mira todos los requisitos previos para tu examen de certificación MOS, cuando estés listo podrás agendar la fecha para tu examen de certificación"






}